module.exports = __webpack_public_path__ + "images/help-videos-preview-docs-a6f53d484b511327b66e518f0044241f.png";